import { render, staticRenderFns } from "./CompetitionListHomeLayout.vue?vue&type=template&id=d8537222&scoped=true"
import script from "./CompetitionListHomeLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListHomeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8537222",
  null
  
)

export default component.exports